module.exports = __webpack_public_path__ + "static/media/corn-icon.da3e9471.svg";